import { Map } from 'immutable'
import { getPmSectionData } from '../../../pm-section/index'

export const selectSpotlightSectionById = (state, sectionId) => {
  const { pmSection } = state
  const hasSectionData = Boolean(getPmSectionData({ pmSection, sectionId }))
  const sectionProcessing = pmSection.getIn([sectionId, 'processing'])

  const sectionPlacementData = getPmSectionData({ pmSection, sectionId }) || Map()
  // getPmSectionData returns the app object (stored as section.data in Redux)
  // app.data is the union type data, so tabs are at data.data.tabs
  const pmPlacementData = sectionPlacementData.getIn(['data', 'tabs', 0], Map()) || Map()
  const contentItem = sectionPlacementData.getIn(['data', 'tabs', 0, 'tabContent', 0], Map()) || Map()
  const contentType = contentItem.get('contentType')
  const contentId = contentItem.get('contentId')
  const hasPlacementData = !!contentId
  const payloadType = pmPlacementData.get('payloadType', null)
  const source = pmPlacementData.get('pineSource', null)
  const score = pmPlacementData.get('pineScore', null)
  const merchEventId = pmPlacementData.get('merchEventId', null)
  const campaignId = contentItem.get('contentId')
  const campaignName = contentItem.get('label') || ''
  const viewMode = pmPlacementData.get('viewMode')
  const slug = pmPlacementData.get('slug', null)

  return {
    hasSectionData,
    pmPlacementData: contentItem,
    payloadType,
    contentType,
    contentId,
    hasPlacementData,
    campaignId,
    campaignName,
    merchEventId,
    source,
    score,
    processing: sectionProcessing,
    viewMode,
    slug,
  }
}

export default selectSpotlightSectionById
